import { render, staticRenderFns } from "./checkSetOrderLabels.vue?vue&type=template&id=389ff41f&"
import script from "./checkSetOrderLabels.vue?vue&type=script&lang=js&"
export * from "./checkSetOrderLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "checkSetOrderLabels.vue"
export default component.exports